<template>
    <div :class="containerClassName"></div>
</template>

<script>
    import lottie from 'lottie-web';
    import _animation from '~spa/components/Lottie/_animation.js';

    export default {
        props: {
            json: {
                type: String,
                required: true
            }
        },
        mixins: [_animation],
        methods: {
            start() {
                console.log('Loading animation:', this.containerClassName, this.json);
                lottie.loadAnimation({
                    container: document.querySelector(`.${this.containerClassName}`),
                    renderer: 'svg',
                    loop: this.loop,
                    autoplay: true,
                    path: this.json
                });
            }
        },
    }
</script>
